@for (category of categories; track trackById($index, category)) {
  <div
    class="category"
    [class.selected]="category.id === value"
    [attr.title]="category.label"
    (click)="valueChange.emit(category.id); $event.preventDefault()">
    {{ category.label }}
  </div>
}
